// @flow
import React from "react"
import { compose, type HOC } from "recompose"
import withForm from "forms/withForm"
import withUser from "hoc/withUser"
import { stringRequired } from "forms/validators/string"
import { reservationPricingQuery } from "data/reservations/graphql/queries"
import withQuery from "hoc/withQuery"
import TextInput from "forms/Input/Text"
import withMutation from "hoc/withMutation"
import { applyPromoCodeMutation } from "data/subscriptions/graphql/mutations"
import ModalBody from "modals/_Body"
import ModalHeader from "modals/_Header"
import ModalContent from "modals/_Content"
import ModalControls from "modals/_Controls"
import Alert from "forms/Alert"
import type { ReservationPricingQueryInput } from "data/reservations/graphql/queries"
import { Text } from "componentsStyled/Typography/Texts"
import { Wrap } from "componentsStyled/Layout/Wrap"
import Button from "components/Button"

const ApplyPromoCodeModal = ({ error, close, isSubmitting, submit }) => (
  <ModalBody close={close}>
    <ModalHeader close={close} title="Apply Promo Code" />
    <ModalContent>
      <Wrap>
        <Alert>{error}</Alert>
        <TextInput
          name="code"
          type="code"
          label="Promo code"
          placeholder="Enter the code"
          autoComplete="off"
        />
        <Text book black>
          How does it work?
        </Text>
        <Text>• One promo code per reservation</Text>
        <Text>• Terms and conditions may vary per promo code</Text>
      </Wrap>
    </ModalContent>
    <ModalControls>
      <Button loading={isSubmitting} fullwidth>
        Apply promo code
      </Button>
    </ModalControls>
  </ModalBody>
)

const schema = {
  code: stringRequired,
}

type Outter = {|
  close: Function,
  input: ReservationPricingQueryInput,
|}

const enhancer: HOC<*, Outter> = compose(
  withUser(),
  withQuery(reservationPricingQuery, {
    variables: props => ({
      input: props.input,
    }),
  }),
  withMutation(applyPromoCodeMutation),
  withForm({
    schema,
    onSubmit: props => values =>
      props.submitMutation({
        code: values.code,
        userId: props.user.id,
      }),
    onSuccess: props => () => {
      props.close()
      props.refetch()
    },
  }),
)

export default enhancer(ApplyPromoCodeModal)



// WEBPACK FOOTER //
// ./src/modals/ApplyPromoCode/index.js